module.exports = __webpack_public_path__ + "static/media/game_footage.e35048b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/game_footage.png
// module id = 7518
// module chunks = 0